import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import _ from 'lodash';
import Link from 'next/link';
import { routes } from 'env/routes';
import withCustomComponent from 'ui/components/withCustomComponent';

import CardEvent from 'ui/components/cards/CardEvent';
import CardPerkDiscount from 'ui/components/cards/CardPerkDiscount';

@withCustomComponent('EventFeedCard')
@withTranslation()
@inject('appStore')
@observer
class EventFeedCard extends Component {
  componentDidMount() {}

  render() {
    const { t, appStore, event } = this.props;
    const { business } = appStore;

    return (
      <div
        data-component-name={this.props.componentName}
        className="virtual-notification-card"
      >
        <div className="card h-auto p-16 p-md-24 mb-24">
          <header className="media mb-32">
            <div
              className="avatar avatar--48"
              style={{
                backgroundImage: `url(${business.NativeHomeUrlWithLanguage}/business/getlogo?h=144&mode=pad)`,
              }}
            ></div>
            <div className="media-body d-flex justify-content-between pl-16">
              <div>
                <div className="fw-500 text-gray-900">
                  {t('A new event was added: {{Name}}', { Name: event.Name })}
                </div>
                <div className="fs-14 lh-14 text-gray-600">
                  {moment(event.StartDate).format('LLL')}
                </div>
              </div>
            </div>
          </header>
          <div className="d-block mb-32">
            <CardEvent event={event} sizeMedium={true} />
          </div>
          <footer>
            <div className="btn-group">
              <Link href={routes.event_by_id(event)}>
                <a className="btn ">{t('Event details')}</a>
              </Link>

              {event.HasTickets && (
                <Link href={routes.tickets_by_id(event)}>
                  <a className="btn  btn-white">{t('Get tickets')}</a>
                </Link>
              )}
            </div>
          </footer>
        </div>
      </div>
    );
  }
}

export default EventFeedCard;
